import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { baseURL1 } from '../Redux/baseURL';
import { useDispatch } from 'react-redux';
import {
	googleSuccess,
	login_success,
} from '../Redux/ActionCreator';

const ProtectedRoute = (props) => {
  // initialize useSelector hook
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isAuth = useSelector(prev => prev.login);
  const userLink = useSelector(e => e.userLink);
  const link = userLink.message;
  const params = new URLSearchParams(window.location.search).get('token');
	const profile_stat = new URLSearchParams(window.location.search).get('profile_status');
	const acctType = new URLSearchParams(window.location.search).get('AcctType');
  console.log("Parameter", params);

  useEffect(() => {
		// const token = localStorage.getItem('token');
		if (params !== null) {
			localStorage.setItem('token', params);
			dispatch(googleSuccess({profile_status: profile_stat, AcctType: acctType}));
			dispatch(login_success({profile_status: profile_stat, AcctType: acctType}));
		}
	}, [params]);

  const handleAuth = () => {
		// const token = localStorage.getItem('token');
		if (params !== null) {
			localStorage.setItem('token', params);
			dispatch(googleSuccess({profile_status: profile_stat, AcctType: acctType}));
			dispatch(login_success({profile_status: profile_stat, AcctType: acctType}));
    }
  }

  const handleRedirect = () => {
    window.location.assign(link + `?token=${params}&AcctType=${acctType}&profile_status=${profile_stat}`);
  }

  return (
    <>
    { isAuth.isAuthenticated === true ? 
    <>
    {link !== null ? handleRedirect() : props.children}
    </> : <>{params !== null ? handleAuth() : window.open(baseURL1, "_self")}</> }
    </>
  )
}

export default ProtectedRoute;

